// frontend/src/components/entry/EntryLoading.jsx
//
// The entry popup while a read it waits on is still in flight: the bar
// names the step, the body says what is happening beside the spinner.

import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography } from '@mui/material';

import EntryDialog from './EntryDialog';

export default function EntryLoading() {
  const { t } = useTranslation();
  return (
    <EntryDialog title={t('entry.loadingTitle')}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <CircularProgress size={28} />
        <Typography color="text.secondary">{t('common.loading')}</Typography>
      </Box>
    </EntryDialog>
  );
}
